module.exports = __webpack_public_path__ + "img/info_icon.a571063c.svg";